module.exports="#define GLSLIFY 1\nuniform vec3 _Color;\n\nvoid main()\n{\n    gl_FragColor = vec4(_Color, 1.0);\n}";